module.exports = __webpack_public_path__ + "40d85cfc1fe51389b1a0f12695cdc389.svg";